import {Component} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {ProviderModel} from "../../../../models/provider.model";
import {GameService} from "../../../../services/game.service";
import {TranslateService} from "@ngx-translate/core";
import {TitleService} from "../../../../services/title.service";
import {Publisher} from "../../../../models/publisher.class";

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.scss']
})
export class ProvidersComponent {

  providers$? : Observable<Publisher[]>;
  titleTranslateSubs?: Subscription;

  constructor(
    private gameService: GameService,
    private translate: TranslateService,
    private titleService: TitleService
  ) {
    this.providers$ = this.gameService.providers$;
  }

  ngOnInit(){
      this.titleTranslateSubs?.unsubscribe();
      this.titleTranslateSubs = this.translate.stream("PROVIDERS.PAGE_TITLE").subscribe(data => {
        this.titleService.setTitle(`Lobby / ${data}`);
      })
  }

  ngOnDestroy(){
    this.titleTranslateSubs?.unsubscribe();
  }


  //use placeholder when the image is not found
  updateNotFoundImgUrl(event: Event) {
    (event.target as HTMLImageElement).src = this.generateProviderSvgPlaceholderUrl((event.target as HTMLImageElement).alt.split(" ")[0]);
  }

  generateProviderSvgPlaceholderUrl(text: string): string {
    const svg = `
    <svg width="300" height="150" xmlns="http://www.w3.org/2000/svg">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center;color:#fff;font-size:50px;font-weight:bold;line-height:1.2;font-family:sans-serif;">${text}</div>
      </foreignObject>
    </svg>
  `;
    return `data:image/svg+xml;base64,${btoa(svg)}`;
  }


}
